import Header from "./Header";
import Splash from "./Splash";

export default {
  Header,
  Splash
};
